import * as React from 'react';

import {
    Button,
    Row,
    Col,
    Container
} from 'reactstrap';

import { ErrorState } from '../ErrorBanner/ErrorBanner';

import { PortalTextBorrowerCustomerCopyEmail } from '../../Models/Api/strongbox.financialportal';

type Props = {
    borrowerEmail: string;
    borrowerEmailChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled: boolean;
    submitBorrowerEmail: () => void;
    errorMsg?: ErrorState;
    rcvCustomerCopyText?: PortalTextBorrowerCustomerCopyEmail;
};

export const ReceiveEmailedDocumentWidget: React.FC<Props> = (props): React.ReactElement => {
    const {
        borrowerEmail,
        borrowerEmailChanged,
        disabled,
        errorMsg,
        submitBorrowerEmail,
        rcvCustomerCopyText,
    } = props;

    return (
        <Container fluid>
            {!!errorMsg && (
                <Row>
                    <Col>
                        <p className={'error-text'}>{errorMsg.summaryMessage}</p>
                        <p className={'error-text'}>{errorMsg.extraInformation}</p>
                    </Col>
                </Row>
            )}
            <Row>
                <Col xs={12} style={{ marginTop: '30px' }} className={'centered-col outlined-column-content'}>
                    <Row>
                        <Col>
                            <label
                                htmlFor={'borrowerEmail'}
                                className={'large'}
                            >
                                {rcvCustomerCopyText?.receiveACopyPrompt || ''}
                            </label>
                        </Col>
                    </Row>
                    <Row className={'basic-height-separator'}>
                        <Col>
                            <input
                                type={'email'}
                                id={'borrowerEmail'}
                                name={'borrowerEmail'}
                                placeholder={rcvCustomerCopyText?.emailPlaceholder || ''}
                                className={'large regular-input'}
                                value={borrowerEmail}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    borrowerEmailChanged(event);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row className={'basic-height-separator'}>
                        <Col>
                            <Button
                                type="button"
                                className={`small regular-button`}
                                disabled={disabled}
                                onClick={() => {
                                    submitBorrowerEmail();
                                }}
                                color="primary"
                            >
                                {rcvCustomerCopyText?.confirmAndSend || ''}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

